(function () {
  if (window.BeiraNewsletterPopup) {
    window.BeiraNewsletterPopup.init(document);
    return;
  }

  var storagePrefix = 'beira_newsletter_popup_closed_br_';
  var controllers = new Map();

  function designMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function storageKey(dialog) {
    return storagePrefix + dialog.dataset.sectionId;
  }

  function dismissed(dialog) {
    if (designMode()) {
      return false;
    }

    try {
      var expiresAt = Number(window.localStorage.getItem(storageKey(dialog)) || 0);
      if (expiresAt > Date.now()) {
        return true;
      }
      window.localStorage.removeItem(storageKey(dialog));
    } catch (error) {
      return false;
    }

    return false;
  }

  function rememberDismissal(dialog) {
    if (designMode()) {
      return;
    }

    var frequency = Number(dialog.dataset.frequencyDays) || 30;
    var expiresAt = Date.now() + frequency * 24 * 60 * 60 * 1000;

    try {
      window.localStorage.setItem(storageKey(dialog), String(expiresAt));
    } catch (error) {
      return;
    }
  }

  function PopupController(dialog) {
    this.dialog = dialog;
    this.timer = null;
    this.returnFocus = null;
    this.closeButton = dialog.querySelector('[data-newsletter-popup-close]');
    this.status = dialog.querySelector('[data-newsletter-popup-status]');
    this.handleCloseButton = this.handleCloseButton.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    this.handleNativeClose = this.handleNativeClose.bind(this);
  }

  PopupController.prototype.init = function () {
    if (this.dialog.dataset.newsletterPopupInitialized === 'true') {
      return;
    }

    this.dialog.dataset.newsletterPopupInitialized = 'true';
    this.closeButton.addEventListener('click', this.handleCloseButton);
    this.dialog.addEventListener('cancel', this.handleCancel);
    this.dialog.addEventListener('click', this.handleBackdropClick);
    this.dialog.addEventListener('close', this.handleNativeClose);

    if (window.location.pathname === '/challenge') {
      return;
    }

    if (this.status) {
      this.schedule(0);
      return;
    }

    if (!dismissed(this.dialog)) {
      this.schedule(Number(this.dialog.dataset.delay) || 4);
    }
  };

  PopupController.prototype.schedule = function (delaySeconds) {
    var controller = this;
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(function () {
      controller.open();
    }, delaySeconds * 1000);
  };

  PopupController.prototype.open = function () {
    if (!this.dialog.isConnected || this.dialog.open) {
      return;
    }

    this.returnFocus = document.activeElement;
    this.dialog.showModal();
    document.documentElement.classList.add('beira-newsletter-popup-open');

    var focusTarget = this.dialog.querySelector('[data-newsletter-popup-focus]') || this.closeButton;
    window.requestAnimationFrame(function () {
      focusTarget.focus({ preventScroll: true });
    });
  };

  PopupController.prototype.close = function (persist) {
    window.clearTimeout(this.timer);

    if (persist) {
      rememberDismissal(this.dialog);
    }

    if (this.dialog.open) {
      this.dialog.close();
    } else {
      this.handleNativeClose();
    }
  };

  PopupController.prototype.handleCloseButton = function () {
    this.close(true);
  };

  PopupController.prototype.handleCancel = function (event) {
    event.preventDefault();
    this.close(true);
  };

  PopupController.prototype.handleBackdropClick = function (event) {
    if (event.target === this.dialog) {
      this.close(true);
    }
  };

  PopupController.prototype.handleNativeClose = function () {
    document.documentElement.classList.remove('beira-newsletter-popup-open');

    if (this.returnFocus && this.returnFocus.isConnected) {
      this.returnFocus.focus({ preventScroll: true });
    }
  };

  PopupController.prototype.destroy = function () {
    window.clearTimeout(this.timer);
    this.closeButton.removeEventListener('click', this.handleCloseButton);
    this.dialog.removeEventListener('cancel', this.handleCancel);
    this.dialog.removeEventListener('click', this.handleBackdropClick);
    this.dialog.removeEventListener('close', this.handleNativeClose);
    this.close(false);
  };

  function init(root) {
    var dialogs = root.querySelectorAll('[data-newsletter-popup]');

    dialogs.forEach(function (dialog) {
      if (controllers.has(dialog)) {
        return;
      }

      var controller = new PopupController(dialog);
      controllers.set(dialog, controller);
      controller.init();
    });
  }

  function sectionController(sectionId) {
    var match = null;
    controllers.forEach(function (controller) {
      if (controller.dialog.dataset.sectionId === sectionId) {
        match = controller;
      }
    });
    return match;
  }

  window.BeiraNewsletterPopup = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var controller = sectionController(event.detail.sectionId);
    if (controller) {
      controller.open();
    }
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var controller = sectionController(event.detail.sectionId);
    if (controller) {
      controller.close(false);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var controller = sectionController(event.detail.sectionId);
    if (controller) {
      controller.destroy();
      controllers.delete(controller.dialog);
    }
  });
})();
